import styled from "styled-components";
import { typography, colors } from "@joinTrilo/ui/tokens";
import Card from "@joinTrilo/ui/atoms/Card";

export const StyledAuthWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    width: 100%;
    padding-top: 1.6rem;
`;

export const StyledAppleSSO = styled.div<{ display: boolean }>`
    display: ${({ display }) => (display ? "flex" : "none")};
    flex-direction: column;
    width: 100%;
`;

export const StyledGoogleSSO = styled.div<{ display: boolean }>`
    display: ${({ display }) => (display ? "flex" : "none")};
    flex-direction: column;
    width: 100%;
`;

export const StyledFormContainer = styled(Card)<{ display: string }>`
    display: ${({ display }) => (display ? "flex" : "none")};
    flex-direction: column;
    padding: 1.6rem;
    gap: 1.6rem;

    width: 100%;
`;

export const StyledFormWrapper = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
`;

export const StyledTerms = styled.div`
    color: ${colors.deepGrey};
    font-size: 1.2rem;
    text-align: center;
`;

export const StyledWarningBubble = styled(Card)`
    margin-top: 1.6rem;
    padding: 1.6rem;
    border: ${colors["warning"]} !important;
    font: ${typography.fonts.subHeadingLarge};
    color: ${colors.failure};
`;

export const StyledFieldWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 0.4rem;
`;

export const StyledForgotPassWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    width: 100%;

    color: ${colors.darkTurquoise};
    font: ${typography.fonts.largeLabel};
`;

export const StyledWordingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    width: 100%;
`;

export const StyledButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    gap: 1.6rem;
`;

export const StyledHeader = styled.div`
    color: ${colors.deepBlack};
    font: ${typography.fonts.h5};
`;

export const StyledBody = styled.div`
    color: ${colors.deepGrey};
    font: ${typography.fonts.subHeadingSmall};
`;
